import { render } from "./allProducts.vue?vue&type=template&id=28e4ee8e&ts=true"
import script from "./allProducts.vue?vue&type=script&lang=ts"
export * from "./allProducts.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__